export enum ActionTypes {
    RDIO_UI_UPDATED = 'RDIO_UI_UPDATED',
    RDIO_SCHEMA_INSTALLED = 'RDIO_SCHEMA_INSTALLED',
    
}



// WEBPACK FOOTER //
// ./src/sub-projects/radario/types/action-types.ts